export function squarify(nodes, x, y, width, height) {
    var items = nodes
        .map(function (n) { var _a; return ({ name: n.name, value: (_a = n.value) !== null && _a !== void 0 ? _a : sumChildren(n) }); })
        .filter(function (n) { return n.value > 0; });
    var total = items.reduce(function (a, b) { return a + b.value; }, 0) || 1;
    var rects = [];
    layoutRow(items, x, y, width, height, total, rects);
    return rects;
}
function sumChildren(n) {
    var _a;
    if (n.value != null)
        return n.value;
    if (!((_a = n.children) === null || _a === void 0 ? void 0 : _a.length))
        return 1;
    return n.children.reduce(function (a, c) { return a + sumChildren(c); }, 0);
}
function layoutRow(items, x, y, w, h, total, out) {
    if (!items.length)
        return;
    if (items.length === 1) {
        out.push({ name: items[0].name, x: x, y: y, width: w, height: h, value: items[0].value });
        return;
    }
    var horizontal = w >= h;
    var sum = items.reduce(function (a, b) { return a + b.value; }, 0);
    var rowValue = items[0].value;
    var rowFrac = rowValue / sum;
    if (horizontal) {
        var rw = w * rowFrac;
        out.push({ name: items[0].name, x: x, y: y, width: rw, height: h, value: items[0].value });
        layoutRow(items.slice(1), x + rw, y, w - rw, h, total - rowValue, out);
    }
    else {
        var rh = h * rowFrac;
        out.push({ name: items[0].name, x: x, y: y, width: w, height: rh, value: items[0].value });
        layoutRow(items.slice(1), x, y + rh, w, h - rh, total - rowValue, out);
    }
}
export function flattenHierarchy(root) {
    var _a;
    var out = [];
    var walk = function (n) {
        var _a;
        if (!((_a = n.children) === null || _a === void 0 ? void 0 : _a.length))
            out.push(n);
        else
            n.children.forEach(walk);
    };
    if ((_a = root.children) === null || _a === void 0 ? void 0 : _a.length)
        root.children.forEach(walk);
    else
        out.push(root);
    return out;
}
